import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {ServerUrl} from '../../../../../api/ServerUrl';
import { ProtectAPi } from '../../../../../api/ProtectAPi';
import swal from 'sweetalert';
import BackButton from '../../../../tools/BackButton';

const AwardEdit = () => {

    const { http } = ProtectAPi();
    const httpCPage = ServerUrl;
    const [loader, setLoader] = useState('off');
    const { id } = useParams();
    const [bannerTitle, setBannerTitle] = useState('');
    const [bannerTitleError, setBannerTitleError] = useState('');
    const [banner, setBanner] = useState(null);
    const [bannerError, setBannerError] = useState(null);
    const [imagePreview, setImagePreview] = useState('');

    useEffect(() => {
        http.get(`/get-single-home-award/${id}`)
            .then(res => { 
                setBannerTitle(res.data.category);
                const bannerImage = res.data.image;
                if (bannerImage) {
                    const userImageShow = `${httpCPage}/backend/img/award/${bannerImage}`;
                    setImagePreview(userImageShow);
                }
            })
            .catch(error => {
                console.error('Error fetching permissions:', error);
            });
    }, []);

    const submitForm = () => {
        setLoader('on');
        const formData = new FormData();
        formData.append('category', bannerTitle);
        formData.append('banner', banner);

        http.post(`/pages-home-award-update/${id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }).then(res => {
            if (res.data.status === '422') {
                const errors = res.data.error;
                setLoader('off');
                setBannerError(errors.banner ? errors.banner[0] : '');
                setBannerTitleError(errors.category ? errors.category[0] : '');
            } else {
                setLoader('off');
                swal('Success', res.data.msg, 'success');
            }
        }).catch(error => {
            console.error('Error:', error);
        });
    };

    const handleImageChange = (e) => {
        const selectedImage = e.target.files[0];
        setBanner(selectedImage);
        const previewURL = URL.createObjectURL(selectedImage);
        setImagePreview(previewURL);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'bannerTitle') {
            setBannerTitle(value);
        } 
    };


  return (
    <div>
        <div className="main-content">
                <section className="section">
                    <div className="section-body">
                        <div className="row">
                            <div className="col-12">
                                <div className="card card-primary">
                                    <div className="card-body">
                                        <div className="d-flex justify-content-between">
                                            <h5>Add Award</h5>
                                            <div className="">
                                                <BackButton/>
                                            </div>
                                        </div>
                                        <div className="card-body pb-0">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>Award Title</label>
                                                        <input type="text" id="bannerTitle" name="bannerTitle" value={bannerTitle} className="form-control ms-0" placeholder='Award tiltle' onChange={handleInputChange} />
                                                        <span className='text-danger'>{bannerTitleError}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="logo-box">
                                                        <div className="logo">
                                                            <label className='' htmlFor="userImage">
                                                                <div className="image-box border dottet p-2 rounded">
                                                                    {imagePreview ? (
                                                                        <img src={imagePreview} className='img-fluid' alt="Preview" />
                                                                    ) : (
                                                                            <img src="https://w7.pngwing.com/pngs/159/705/png-transparent-computer-computer-trademark-computer-logo.png" className='img-fluid' alt="Default" />
                                                                        )}
                                                                </div>
                                                                <input type="file" id="userImage" className="form-control d-none" onChange={handleImageChange} /> <span className='btn btn-primary mt-1 w-100'>Change Award</span>
                                                                <span className='text-danger'>{bannerError}</span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="text-center mt-5">
                                            <label className="col-form-label"></label>
                                            {loader === 'off' &&
                                                <button type="submit" onClick={submitForm} className="btn btn-primary">Update</button>
                                            }
                                            {loader === 'on' &&
                                                <div class="spinner-border text-dark" role="status"></div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
    </div>
  )
}

export default AwardEdit;
